import { apiRequest } from "./client";

export type BitrixNotificationStatus =
  | "queued"
  | "sending"
  | "sent"
  | "failed"
  | "dlq";

export type BitrixNotificationKind = "hot_lead" | "expiry_reminder";

export interface BitrixNotification {
  id: string;
  dispatch_id: string;
  manager_user_id: string;
  bitrix_user_id: string;
  notification_kind: BitrixNotificationKind;
  status: BitrixNotificationStatus;
  message_preview: string;
  execute_at: string;
  attempt_count: number;
  last_error: string | null;
  sent_at: string | null;
  dlq_at: string | null;
  created_at: string;
}

export interface BitrixNotificationListResponse {
  items: BitrixNotification[];
  total_count: number;
}

export interface BitrixNotificationListQuery {
  page?: number;
  size?: number;
  status?: BitrixNotificationStatus;
  dispatch_id?: string;
}

export interface BitrixHealth {
  webhook_configured: boolean;
  queued: number;
  sending: number;
  sent_recent_24h: number;
  dlq: number;
  failed: number;
  last_dlq_at: string | null;
}

function buildQuery(query: BitrixNotificationListQuery): string {
  const params = new URLSearchParams();
  if (query.page !== undefined) params.set("page", String(query.page));
  if (query.size !== undefined) params.set("size", String(query.size));
  if (query.status !== undefined) params.set("status", query.status);
  if (query.dispatch_id !== undefined)
    params.set("dispatch_id", query.dispatch_id);
  const s = params.toString();
  return s ? `?${s}` : "";
}

export const bitrixApi = {
  listNotifications: (query: BitrixNotificationListQuery = {}) =>
    apiRequest<BitrixNotificationListResponse>(
      `/bitrix/notifications${buildQuery(query)}`,
    ),
  health: () => apiRequest<BitrixHealth>("/bitrix/health"),
  retry: (id: string) =>
    apiRequest<BitrixNotification>(`/bitrix/notifications/${id}/retry`, {
      method: "POST",
      body: {},
    }),
};
